module.exports = __webpack_public_path__ + "static/media/g2Review2.9aaad245.png";